import { Button, Tooltip } from '@mui/material';
import { Grid } from '@mui/system';
import { GridButtonWithTooltipProps } from './types';

const GridButtonWithTooltip = (props: GridButtonWithTooltipProps) => {
  const { buttonText, className, disabled, icon = null, onClick, tooltipText } = props;
  return (
    <Grid container>
      <div>
        <Tooltip arrow title={tooltipText}>
          <span>
            <Button className={className} disabled={disabled} onClick={onClick} startIcon={icon} variant="outlined">
              {buttonText}
            </Button>
          </span>
        </Tooltip>
      </div>
    </Grid>
  );
};

export default GridButtonWithTooltip;
